import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const goToCheckout = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Guía Maximiza tu Seguro Social',
        content_type: 'product',
        value: 27.0,
        currency: 'USD'
      });
    }
    window.open('https://tiendadelibrosdigital.com/cart/42545816797255:1', '_blank');
  };
  return <section className="relative w-full bg-gradient-to-b from-[#0F1D33] to-[#1B2A4A] overflow-hidden py-16 md:py-24" data-id="element-64">
      {/* Decorative gold lines */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-65">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full border border-[#C5A55A]/20 blur-sm" data-id="element-66" />
        <div className="absolute bottom-[10%] -right-[10%] w-[40%] h-[60%] rounded-full border border-[#C5A55A]/20 blur-sm" data-id="element-67" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-68">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-69">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-70">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3,
            duration: 0.8
          }} className="inline-block mb-4 px-4 py-1.5 rounded-full border border-[#C5A55A]/40 bg-[#C5A55A]/10 text-[#E8D5A3] text-sm font-medium tracking-wider uppercase" data-id="element-71">
              Edición 2026 · Nueva Era
            </motion.div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#C5A55A] mb-6 drop-shadow-sm" data-id="element-72">
              Guía: Maximiza tu Seguro Social
            </h1>

            <p className="text-xl md:text-2xl text-white/90 mb-10 font-light leading-relaxed" data-id="element-73">
              El plan paso a paso para que la mujer hispana en USA asegure cada
              dólar que le corresponde legalmente,{' '}
              <strong className="text-[#E8D5A3] font-semibold" data-id="element-74">
                sin errores y sin depender de traductores.
              </strong>
            </p>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={goToCheckout} className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[#C5A55A] hover:bg-[#b39550] text-[#0F1D33] text-lg md:text-xl font-bold py-5 px-8 rounded-full shadow-[0_0_20px_rgba(197,165,90,0.4)] transition-all duration-300" aria-label="Comprar la guía ahora" data-id="element-75">
              SÍ, QUIERO MAXIMIZAR MI SEGURO SOCIAL
              <ChevronRight className="w-6 h-6" data-id="element-76" />
            </motion.button>

            <p className="mt-4 text-[#E8D5A3]/70 text-sm flex items-center justify-center lg:justify-start gap-2" data-id="element-77">
              <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" data-id="element-78" />
              Actualizado para las leyes de 2026
            </p>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-79">
            <div className="relative aspect-[4/3] lg:aspect-square w-full" data-id="element-80">
              <motion.img animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 5,
              ease: 'easeInOut'
            }} src="https://cdn.magicpatterns.com/uploads/uq7EwAPHN1vxb6kUMCUedk/cover_ddel_libro.png" alt="Portada de la Guía Maximiza tu Seguro Social en tablet y teléfono" className="object-contain w-full h-full drop-shadow-2xl" data-id="element-81" />
            </div>
            {/* Glow effect behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#C5A55A]/20 blur-[100px] -z-10 rounded-full" data-id="element-82" />
          </motion.div>
        </div>
      </div>
    </section>;
}